namespace ui
{
	export namespace utils
	{
		export namespace Object
		{
			export function ExtractFillObject(
				obj: { [ key: string ]: any },
				name: string,
				input: ui.Form.BasicInputField<HTMLElement>
			): { [ key: string ]: any }
			{
				const names: string[]	= name.split( '.' );
				const pname: string		= names[ 0 ];

				if ( names.length === 1 )
				{
					if ( input instanceof ui.Form.BasicDateBasedInput )
					{
						obj[ pname ] =
						{
							format:	input.FormatPattern,
							value:	new Date( input.val() ).pattern( input.FormatPattern ),
						};
					}
					else
					{
						obj[ pname ] = input.val();
					}
				}
				else
				{
					obj[ pname ] = ExtractFillObject( obj[ pname ] || {}, ( names.splice( 1 ) ).join( '.' ), input );
				}

				return obj;
			}
		}
	}
}
